import { bool, shape, string } from "prop-types";

import __ from "web/Layout/Translations";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import Configurable from "./Configurable";
import classes from "./top.scss";

const ProductCardTop = ({ className, isAnnouncement, options }) => {
  switch (true) {
    case !!isAnnouncement: {
      return (
        <div className={className}>
          <div className={classes.announcement}>{__("Zapowiedź")}</div>
        </div>
      );
    }
    case Boolean(
      options &&
        options.configurable_options &&
        isArrayHasItems(options.configurable_options.attributes)
    ): {
      const firstAttribute = options.configurable_options.attributes[0];
      const { code, options: optionsAttr } =
        typeof firstAttribute === "object" ? firstAttribute : {};
      return (
        <div className={`${className} ${classes.hidden}`}>
          <Configurable code={code} options={optionsAttr} />
        </div>
      );
    }
    default: {
      return null;
    }
  }
};

ProductCardTop.propTypes = {
  className: string.isRequired,
  isAnnouncement: bool,
  options: shape({}),
};

ProductCardTop.defaultProps = {
  isAnnouncement: false,
  options: {},
};

export default ProductCardTop;
